import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Form } from "react-bootstrap";
import { Input, Select, Table, Pagination, PrintModal, Button } from "../../../../components";
import { paymentMethods , pass } from "../../../../constants";
import { convertPhone, jsonToXlsx, scrollToTop } from "../../../../methods";
import { axios, moment } from "../../../../boot";
import { toast } from "../../../../methods";
import VpsInfo from "../VpsInfo";

export default function ZarinPalVps() {
  const basicParams = JSON.parse(sessionStorage.getItem("params")) ?? {};
  
  const navigate = useNavigate();
  const [params, setParams] = useState({ page: 1, ...basicParams });
  const [purchases, setPurchases] = useState([]);
  const [pages, setPages] = useState({});
  const [modalInfo, setModalInfo] = useState(null)
  const [update, setUpdate] = useState(0)
  const [ phone , setPhone ] = useState("")

  const purchaseStatus = [
    {
      name: "تایید شده",
      id: "success",
      color: "success",
      isUpdateStatus: true,
      filterable: true,
    },
    {
      name: "رد شده",
      id: "failed",
      color: "danger",
      filterable: true,
    },
    {
      name: "در انتظار تایید",
      id: "pending",
      color: "warning",
      filterable: true,
    },
  ]

  const saveParams = () => {
    const value = JSON.stringify(params);
    sessionStorage.setItem("params", value);
  };
  const getPurchases = (enter) => {
    saveParams();
    const url = "https://api.marveltrade.org/api/admins/accountantorders";
    const config = {
      params: {
        userName :enter,
        pass,
        sort: "createdAt:-1",
        perPage: 20,
        paymentMethod : "IRR",
        ...params,
      },
    };
    params.date &&
      ([config.params.startDate, config.params.endDate] = params.date);
    delete config.params.date;
    config.params.phone && (config.params.phone = convertPhone(params.phone))
    axios.get(url, config).then(({ data }) => {
      setPurchases(data.data);
      setPages(data.pages);
      scrollToTop();
    });
  };
  const downloadXlsx = async () => {
    const url = "https://api.marveltrade.org/api/admins/accountantorders";
    const perPage = 100;
    const totalPages = Math.ceil(pages.totalItems / perPage);
    const config = (page) => ({ params: { ...params,userName : phone , pass,  perPage, page , paymentMethod : "IRR" } });
    const getAllData = await [...Array(totalPages)]
      .map((e, i) => i + 1)
      .map(
        async (page) => await (await axios.get(url, config(page))).data?.data
      );
    const allData = await Promise.all(getAllData);
    const title = "report";
    const json = allData.flat().map((e , index) => ({
      "ردیف" : `${index+1}` ,
      تاریخ: moment.miladiToShamsi({ date: e.createdAt }),
      خدمات: e.content
      ?.map((e) => `${e.name} ${e.count} عدد`)
      .join(" - "),
      "نوع مشترک" : "حقیقی",
      "کد ملی"  : `${e?.codeMelli ? e?.codeMelli : "" }`,
      "نام کاربر": `${e.user[0]?.firstName} ${e.user[0]?.lastName}`,
      "نام کشور سرور": e?.content?.map((e)=> e.location).join(" - "),
      "شماره موبایل": `${convertPhone(e.user[0]?.phone)}`,
      "نوع پرداخت": paymentMethods.find((mt) => mt.id === "IRR")
        ?.name,
      قیمت: e.content?.map((item) => `${item.totalPrice} تومان -  ${item.totalPriceUsd} تتر`).join(" - "),
      "درصد تخفیف" : e.content[0]?.off ? e.content[0]?.off : "بدون تخفیف",
      وضعیت: purchaseStatus.find((it) => it.id === e.status)?.name,
    }));
    jsonToXlsx({ json, title });
  };
  const formControls = [
    {
      label: "تاریخ",
      state: "date",
      type: "date",
      cancelBtn: true,
    },
    {
      label: "نام",
      state: "firstName",
      type: "text",
      clear: true,
    },
    {
      label: "نام خانوادگی",
      state: "lastName",
      type: "text",
      clear: true,
    },
    {
      label: "شماره پیگیری",
      state: "refId",
      type: "number",
      clear: true,
    },
    {
      label: "شماره تلفن",
      state: "phone",
      type: "number",
      clear: true,
    },

    {
      tag: Select,
      label: "وضعیت",
      state: "status",
      cancelBtn: true,
      items: purchaseStatus.filter((e) => e.filterable),
    },
  ];
  const showStatus = (id = 0) => {
    const { color, name } = purchaseStatus.find((e) => e.id === id) ?? {};
    return <span className={`text-${color} fw-bold`}>{name}</span>;
  };

  useEffect(()=>{
    const getPhone = JSON.parse(localStorage.getItem('phone'))
    setPhone(getPhone)
    getPurchases(getPhone)
  }, [params, update]);
  return (
    <React.Fragment>
      <PrintModal show={modalInfo != null} onHide={() => setModalInfo(null)} size="lg">
        <VpsInfo data={modalInfo} onUpdate={setUpdate} purchaseType="IRR" />
      </PrintModal>


      <div>
        <button
          className="bi bi-filetype-xlsx fs-3 text-success"
          onClick={downloadXlsx}
        />
      </div>
      <Row className="d-print-none">
        {formControls.map((e) => (
          <Col key={e.state} xs="12" md="6" lg="4">
            {React.createElement(e.tag ?? Input, {
              ...e,
              value: params[e.state],
              setValue: (val) => {
                setPurchases([]);
                setParams((p) => ({ ...p, page: 1, [e.state]: val }));
              },
            })}
          </Col>
        ))}
      </Row>

      <Table className="d-print-none">
        <thead>
          <tr>
            <th>شماره پیگیری</th>
            <th>نام خریدار</th>
            <th>شماره تلفن</th>
            <th>تاریخ</th>
            <th>مبلغ نهایی</th>
            <th>تخفیف</th>
            <th>نوع خدمت</th>
            <th>وضعیت</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {purchases.map((e, i) => (
            
            <tr key={e._id + i}  >
              <td>{e?.refId ? e.refId : ""}</td>
              <td onClick={() => setModalInfo(e)}>
                {e.user[0]?.firstName} {e.user[0]?.lastName}
              </td>
              <td>{convertPhone(e.user[0]?.phone)}</td>
              <td onClick={() => setModalInfo(e)}>
                <span dir="ltr">
                  {moment.miladiToShamsi({
                    date: e.createdAt,
                    format: "jYYYY/jMM/jDD - HH:mm:ss",
                  })}
                </span>
              </td>
              <td onClick={() => setModalInfo(e)} className="text-success">{`${e.content[0]?.totalPrice} تومان -  ${e.content[0]?.totalPriceUsd} تتر`}</td>
              <td onClick={() => setModalInfo(e)} className="text-danger">
                {e.content[0]?.off > 0
                  ? `${e.content[0]?.off} تومن -  ${e.content[0]?.off} تتر`
                  : "بدون تخفیف"}
              </td>
              <td onClick={() => setModalInfo(e)} className="fw-bold">سرور مجازی</td>
              <td onClick={() => setModalInfo(e)}>{showStatus(e.status)}</td>

            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        totalPages={pages.totalPages}
        activePage={params.page}
        setActivePage={(page) => setParams((p) => ({ ...p, page }))}
      />
      {/* {params.page < pages.totalPages && (
        <button
          className="d-block mx-auto w-fit text-primary"
          onClick={() => {
            setParams((p) => ({ ...p, page: p.page + 1 }));
          }}
        >
          نمایش بیشتر...
        </button>
      )} */}
    </React.Fragment>
  );
}
